/** An environment is a data selector; membership and live lease checks still authorize access. */
export function environmentId(value: string | undefined) {
  if (!value || !/^(?:default|pr-[1-9][0-9]{0,8})$/.test(value))
    throw new Error('AddAva environment is not configured');
  return value;
}
export function environmentHeaders(value: string | undefined) {
  return { 'x-addava-environment': environmentId(value) };
}
